import { Banner } from '@loadsmart/miranda-react'

export function ChatError() {
  return (
    <Banner variant="danger">
      <Banner.Description>
        The chat is unavailable at the moment, please try again later
      </Banner.Description>
    </Banner>
  )
}
